import React from 'react';
import SplashScreen from 'js/components/splash-screen/SplashScreen';

const Main = ({ children }) => {
  return (
    <main role="main" className="container" style={{ position: 'relative' }}>
      <SplashScreen />
      {children}
    </main>
  );
};

export default Main;
